import { z } from 'zod';

const strongPassword = z
  .string()
  .min(8, 'At least 8 characters')
  .regex(/[a-z]/, 'Needs a lowercase letter')
  .regex(/[A-Z]/, 'Needs an uppercase letter')
  .regex(/[0-9]/, 'Needs a number');

export const createUserFormSchema = z.object({
  firstName: z.string().trim().min(1, 'Required'),
  lastName: z.string().trim().min(1, 'Required'),
  email: z.string().email('Enter a valid email address'),
  phone: z.string().trim().optional().or(z.literal('')),
  password: strongPassword,
  roleId: z.coerce.number().int().min(1, 'Required'),
  branchId: z.coerce.number().int().optional(),
});

export const updateUserFormSchema = z.object({
  firstName: z.string().trim().min(1, 'Required'),
  lastName: z.string().trim().min(1, 'Required'),
  phone: z.string().trim().optional().or(z.literal('')),
  roleId: z.coerce.number().int().min(1, 'Required'),
  branchId: z.coerce.number().int().optional(),
});

export const resetUserPasswordFormSchema = z
  .object({
    newPassword: strongPassword,
    confirmPassword: z.string(),
  })
  .refine((v) => v.newPassword === v.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type CreateUserFormValues = z.infer<typeof createUserFormSchema>;
export type UpdateUserFormValues = z.infer<typeof updateUserFormSchema>;
export type ResetUserPasswordFormValues = z.infer<typeof resetUserPasswordFormSchema>;
